import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { Http, RequestOptions, Headers } from '@angular/http';


import { DatosService } from '../../datos.service';

@Component({
  selector: 'app-body',
  templateUrl: './body.component.html',
  styleUrls: ['./body.component.css']
})
export class BodyComponent implements OnInit {
  mes: any[] = [];
  sos: any[] = [];
  meds: any[] = [];
  caps: any[] = [];

  showSelected: boolean;
  temp: any;

  contact: FormGroup;

  constructor(
    private _datosService: DatosService,
    private fb: FormBuilder,
    private http: Http
  ) {
    this.createForm();
  }

  ngOnInit() {
    this.mes = this._datosService.getMedioAmbiente();
    this.sos = this._datosService.getSaludOcupacional();
    this.meds = this._datosService.getMediciones();
    this.caps = this._datosService.getCapacitaciones();
  }

  createForm() {
    this.contact = this.fb.group({
      nombre: ['', Validators.required],
      email: ['', Validators.email],
      asunto: ['', Validators.required],
      mensaje: ['', Validators.required]
    });
  }
  mostrarPopMe(servicio, id) {
    this.showSelected = true;
    this.temp = null;
    this.temp = this._datosService.getElemento(servicio, id);
  }

  close() {
    this.showSelected = false;
  }
  enviarMenmsaje() {
    if (this.contact.valid) {
      let op = new RequestOptions();
      op.headers = new Headers();
      op.headers.append('Content-Type', 'application/json');
      this.http
        .post(
          'http://integramai.com/assets/mailer/mailer.php',
          JSON.stringify(this.contact.value)

        )
        .subscribe(
          data => {
            console.log('OKKKKKKKKKKKKK');
          },
          error => {
            console.log(JSON.stringify(error.json()));
          }
        );
    } else {
      console.log('error no se puedo enviar');
    }
  }
}




// WEBPACK FOOTER //
// G:/proyectos/website - IntergraMAI/webMai/src/app/component/body/body.component.ts